import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Login from './pages/Login';
import SubscriptionPage from './pages/SubscriptionPage';
import Verify from "./pages/Verify";
import Success from "./pages/Success"; // ✅ Add Success Page

function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/subscribe" element={<SubscriptionPage />} />
      <Route path="/verify" element={<Verify />} />
      <Route path="/success" element={<Success />} /> {/* 🎯 New Success Checkout Route */}
    </Routes>
  );
}

export default App;
